import styled from 'styled-components';

export const Wrapper = styled.div`
  width: 100%;
  box-sizing: border-box;
`;

export const Header = styled.div`
    background: #009878;
`;

export const Title = styled.h1`
  margin: 0;
  font-size: 2.5rem;
  font-weight: bold;
  color: #ffffff;
  padding: 28px 16px 4px 16px;
`;

export const Subtitle = styled.p`
  margin: 0;
  font-size: 1.2rem;
  font-weight: 400;
  color: #ffffff;
  background: #009878;
  padding: 0 16px 16px 16px;
`;

export const Section = styled.div`
  padding: 1.5rem 0;
  margin: 0 1rem;
`;

export const Item = styled.div`
  display: flex;
  align-items: center;
  padding: 1rem 1rem;
  font-size: 1rem;
  font-weight: bold;
  color: #222;
    cursor: pointer;
`;

export const IconLeft = styled.div`
  margin-right: 12px;
  display: flex;
  align-items: center;
`;

export const Divider = styled.div`
  width: 100%;
  height: 1px;
  background: #e6e6e6;
`;

export const LogoutWrapper = styled.div`
  margin: 1rem;
    position: fixed;
  left: 16px;
  right: 16px;
  bottom: 80px; 
  z-index: 50;
`;

export const LogoutButton = styled.button`
  width: 100%;
  padding: 12px 0;
  border: 1.5px solid #002b80;
  border-radius: 8px;
  background: white;
  color: #002b80;
  font-size: 1rem;
  font-weight: 600;
  display: flex;
  justify-content: center
`;
